'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleHero = exports.SimpleHeroUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TrackDwell = require('decorators/TrackDwell/TrackDwell');

var _TrackDwell2 = _interopRequireDefault(_TrackDwell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SimpleHeroUnwrapped = exports.SimpleHeroUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(SimpleHeroUnwrapped, _PureComponent);

  function SimpleHeroUnwrapped() {
    (0, _classCallCheck3.default)(this, SimpleHeroUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (SimpleHeroUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(SimpleHeroUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(SimpleHeroUnwrapped, [{
    key: 'onDwell',
    value: function onDwell() {
      var onView = this.props.onView;

      if (onView) {
        onView();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames;

      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          body = _props.body,
          children = _props.children,
          cta = _props.cta,
          footer = _props.footer,
          _props$imageAlignment = _props.imageAlignment,
          imageAlignment = _props$imageAlignment === undefined ? 'left' : _props$imageAlignment,
          imageAlt = _props.imageAlt,
          imageUrl = _props.imageUrl,
          title = _props.title,
          titleSize = _props.titleSize;


      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)((_classNames = {
            'simple-hero': true
          }, (0, _defineProperty3.default)(_classNames, 'simple-hero--' + imageAlignment, true), (0, _defineProperty3.default)(_classNames, 'simple-hero--no-image', !imageUrl), (0, _defineProperty3.default)(_classNames, 'bg--' + backgroundColor, true), _classNames))
        },
        _react2.default.createElement(
          'section',
          null,
          _react2.default.createElement(
            'div',
            { className: 'simple-hero__content' },
            title && _react2.default.createElement(
              'h2',
              { className: 'text--' + (titleSize || 'xl') },
              title
            ),
            body && _react2.default.createElement(
              'p',
              { className: 'simple-hero__body' },
              body
            ),
            cta
          ),
          imageUrl && _react2.default.createElement(
            'div',
            { className: 'simple-hero__image' },
            _react2.default.createElement('img', { src: imageUrl, alt: imageAlt })
          )
        ),
        children,
        footer && _react2.default.createElement(
          'p',
          { className: 'simple-hero__footer' },
          footer
        )
      );
    }
  }]);
  return SimpleHeroUnwrapped;
}(_react.PureComponent);

SimpleHeroUnwrapped.propTypes = {
  backgroundColor: _propTypes2.default.oneOf(['light', 'white']),
  body: _propTypes2.default.node,
  children: _propTypes2.default.node,
  cta: _propTypes2.default.node,
  footer: _propTypes2.default.node,
  imageAlignment: _propTypes2.default.oneOf(['left', 'right']),
  imageAlt: _propTypes2.default.string,
  imageUrl: _propTypes2.default.string,
  onView: _propTypes2.default.func,
  title: _propTypes2.default.node,
  titleSize: _propTypes2.default.string
};

var SimpleHero = exports.SimpleHero = (0, _TrackDwell2.default)(SimpleHeroUnwrapped);